/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Bond product subscription status
 */
export type GetBondRedemptionListResponseDataItemStatus = typeof GetBondRedemptionListResponseDataItemStatus[keyof typeof GetBondRedemptionListResponseDataItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBondRedemptionListResponseDataItemStatus = {
  DRAFT: 'DRAFT',
  QUOTED: 'QUOTED',
  NEW: 'NEW',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  CANCEL: 'CANCEL',
  APPROVE: 'APPROVE',
  FAIL: 'FAIL',
  ERROR: 'ERROR',
} as const;
